import { connect } from 'react-redux';
import { OutboundSuccess } from '../shared/OutboundSuccess';
import { getOutbound, downloadOutboundReceipt } from '../../app/store/actions/imsWarehouseStaffActions';

const WHOutboundSuccess = (props) => (
    <OutboundSuccess
        {...props}
        roleBasePath="/ims/warehouse-staff"
    />
);

const mapStateToProps = (state) => ({
    outbound: state?.records?.outbound,
    isLoading: state?.records?.isLoading || state?.wait?.isLoading,
});

export default connect(mapStateToProps, { getOutbound, downloadOutboundReceipt })(WHOutboundSuccess);
